/**
 * Checks if a specific section in the page form has been filled out.
 * @param {string} key - The section key (e.g., 'meta', 'hero', 'features')
 * @param {object} form - The main page form state object
 * @returns {boolean} - True if the section has valid data, false otherwise
 */
export const isSectionFilled = (key, form) => {
  switch (key) {
    case "meta":
      return !!(form.meta.title && form.meta.slug);
    case "hero":
      return !!form.hero.headlineLine1;
    case "features":
      return form.features.items.some((i) => i.title);
    case "stats":
      return form.stats.items.some((i) => i.value !== "0+");
    case "caseStudies":
      return form.caseStudies.items.length > 0;
    case "faq":
      return form.faq.items.some((i) => i.question);
    case "team":
      return form.team.items.some((i) => i.name);
    case "testimonials":
      return form.testimonials.items.some((i) => i.quote);
    case "pricing":
      return form.pricing.packages.some((p) => p.name);
    case "footer":
      return !!form.footer.description;
    case "contact":
      return !!form.contact.heading;
    default:
      return false;
  }
};
